import { NFTCollectionsStyle } from "./style";

export default function NFTCollections() {
  return (
    <NFTCollectionsStyle>
      {["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"].map(
        (imagePath) => (
          <img
            key={imagePath}
            src={`/img/nft-collections/Bullit NFT Card-${imagePath}.png`}
            alt={`NFT collection-${imagePath}`}
            className="nft-collection"
          />
        )
      )}
    </NFTCollectionsStyle>
  );
}
